<div class="book-info">

    <button (click)="close()" class="close-button" title="Schließen"><i class="fas fa-times"></i></button>

    <div class="wrapper">

        <h4>Darstellung & Buchinhalte</h4>
        <div class="viewmode-switch">
            @if (applicationStateService.bookConfig.readSpeakerEnabled) {
                <button
                        (click)="toggleReadspeaker()"
                        [class.active]="featureActivationService.readspeakerElementsVisible"
                        [position]="'0 0'"
                        [url]="rsToggleImgSrc | asset"
                        backgroundImage class="rs-toggle-button"
                        data-bs-html="true"
                        data-bs-placement="bottom"
                        data-bs-toggle="tooltip"
                        title="Vorlesefunktion <br/><strong>deaktiviert</strong>">
                    <span></span>
                </button>
            }
            <app-feature-menu></app-feature-menu>
            <app-viewmode-switcher></app-viewmode-switcher>
        </div>


        <h4>Infos zu diesem Buch</h4>

        <div class="flex">
            <a [attr.data-bs-toggle]="!applicationStateService.bookConfig.storeLink ? 'tooltip' : null"
               [attr.href]="applicationStateService.bookConfig.storeLink"
               [attr.title]="!applicationStateService.bookConfig.storeLink ? 'Dieses Buch kann leider nicht als E-Book gekauft werden.' : null"
               [class.disabled]="!applicationStateService.bookConfig.storeLink"
               [position]="'center 10px'"
               [size]="'50px'"
               [url]="'/sidebar-quicklinks/store-at-logo.png' | asset"
               backgroundImage
               data-bs-placement="bottom"
               target="_blank">
                <span>E-Book kaufen</span>
            </a>
            <a [attr.data-bs-toggle]="!applicationStateService.bookConfig.productLink ? 'tooltip' : null"
               [attr.href]="applicationStateService.bookConfig.productLink"
               [attr.title]="!applicationStateService.bookConfig.productLink ? 'Dieses Buch ist leider nicht als Printbuch bestellbar.' : null"
               [class.disabled]="!applicationStateService.bookConfig.productLink"
               [position]="'center 10px'"
               [size]="'50px'"
               [url]="'/sidebar-quicklinks/icon-book-shop.png' | asset"
               backgroundImage
               data-bs-placement="bottom"
               target="_blank">
                <span>Buch bestellen</span>
            </a>
            @if (applicationStateService.userData.isTeacher) {
                <a [attr.data-bs-toggle]="!applicationStateService.userData.isTeacher || !applicationStateService.bookConfig.freeDownloadLink ? 'tooltip' : null"
                   [attr.href]="applicationStateService.bookConfig.freeDownloadLink"
                   [attr.title]="!applicationStateService.userData.isTeacher || !applicationStateService.bookConfig.freeDownloadLink? 'Dieses Buch kann leider nicht als PDF heruntergeladen werden.' : null"
                   [class.disabled]="!applicationStateService.userData.isTeacher || !applicationStateService.bookConfig.freeDownloadLink"
                   data-bs-placement="bottom"
                   target="_blank">
                    <i class="fas fa-file-download"></i>
                    <span>PDF Download</span>
                </a>
            }
            <button
                    (click)="createOfflineVersion()"
                    [attr.data-bs-toggle]="!applicationStateService.bookConfig.offlineVersionCreatable ? 'tooltip' : null"
                    [attr.title]="!applicationStateService.bookConfig.offlineVersionCreatable ? 'Dieses Buch kann leider nicht als Offline-Version heruntergeladen werden.' : null"
                    [class.disabled]="!applicationStateService.bookConfig.offlineVersionCreatable"
                    data-bs-placement="bottom">
                <i class="fa fa-download"></i>
                <span>Offline-Version</span>
            </button>
        </div>

        <div class="text-center p-20">
            <button aria-controls="infoCollapse" aria-expanded="false" class="btn btn-sm btn-round" data-bs-target="#infoCollapse"
                    data-bs-toggle="collapse" id="infoButton" type="button">
                Buchinfos anzeigen
            </button>
            <app-editions-dropdown></app-editions-dropdown>
        </div>
        <div class="collapse" id="infoCollapse">
            <div class="card card-body">
                <app-book-info></app-book-info>
            </div>
        </div>

        <div>
            <app-book-additionals></app-book-additionals>
        </div>

        <div>
            <app-last-used-books></app-last-used-books>
        </div>

        <div class="text-start">
            <a [href]="applicationStateService.bookConfig.listLink" class="btn btn-round btn-open btn-semibold">
                zur Buchliste
            </a>
        </div>
    </div>
</div>